export default "__VITE_ASSET__KucEoJ9___"